import api from '../../../services/api';

export const PunchHTTP = {
  get: (params = {}) => api.get('/punches', {params}),
};
